/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
'use strict';

import Accordion from './modules/accordion';
import CookieByte from './modules/cookie-byte';
import Form from './form/form';
import Headermenu from './navigation/navigation';
import ImageGallery from './modules/image-gallery';
import MediaViewer from './modules/media-viewer';
import ImageStack from './modules/image-stack';
import Events from './modules/events';

const siteInitialization = () => {
	CookieByte.init();
	Headermenu.init();
	Accordion.init();
	ImageGallery.init();
	MediaViewer.init();
	Form.init();
	ImageStack.initAll();
	Events.init();
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);
